import React from 'react'
import { Text } from '@fielded/shared-ui'

import emptyState from './assets/emptyStateIcon.png'
import { UploadOutboundsShipmentLink } from '../shared/UploadOutboundsShipmentLink'

const PSMStockTransfersEmptyState = () => {
  return (
    <section className='inbound-shipments-empty-state__wrapper'>
      <div className='inbound-shipments-empty-state__empty-state-img-wrapper'>
        <img className='inbound-shipments-empty-state__empty-state-img' src={emptyState} alt='' />
      </div>
      <section className='inbound-shipments-empty-state__info-wrapper'>
        <Text size='xlarge' bold>No stock transfers yet</Text>
        <Text className='inbound-shipments-empty-state__info'>Import a stock transfer file to log received items and update records.</Text>
      </section>
      <UploadOutboundsShipmentLink url='/shipments/stock-transfers/new/download' />
    </section>
  )
}

export default PSMStockTransfersEmptyState
